module.exports = __webpack_public_path__ + "static/media/03.67b99fe1.webp";